import { Breadcrumb, Button } from "@/components/ui";
import { useSidebar } from "@/components/ui/sidebar";
import { PanelRightCloseIcon, PanelRightOpenIcon } from "lucide-react";
import { UserMenu } from "./app-sidebar/user-menu";

export const AppHeader: React.FC = () => {
  const { state, toggleSidebar } = useSidebar();

  return (
    <header className="flex h-10 shrink-0 items-center justify-between border-b pr-4 pl-2 gap-2">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <Button onClick={toggleSidebar} variant="outline" size="icon" className="size-7 shrink-0">
          {state === "collapsed"
            ? <PanelRightCloseIcon className="size-5 text-muted-foreground" />
            : <PanelRightOpenIcon className="size-5 text-muted-foreground" />}
        </Button>
        <Breadcrumb.Bar />
      </div>
      <div className="flex items-center gap-2">
        <UserMenu />
      </div>
    </header>
  );
};
